import React, { useEffect } from 'react';
import { useUpsell } from './UpsellContext';
const MAIN_PRODUCT_VARIANT_ID = '44804083056726';
const UPSELL_PRODUCT_VARIANT_ID = '44804083515478';
const SHOPIFY_CART_DOMAIN = 'http://impulsodigital.vip/cart/';
const CHECKOUT_MAIN_ONLY = `${SHOPIFY_CART_DOMAIN}${MAIN_PRODUCT_VARIANT_ID}:1`;
const CHECKOUT_WITH_UPSELL = `${SHOPIFY_CART_DOMAIN}${MAIN_PRODUCT_VARIANT_ID}:1,${UPSELL_PRODUCT_VARIANT_ID}:1`;
function goToMainOnlyCheckout() {
  window.location.href = CHECKOUT_MAIN_ONLY;
}
function goToUpsellCheckout() {
  window.location.href = CHECKOUT_WITH_UPSELL;
}
const benefits = ['Más de 1000 recetas para Air Fryer', 'Desayunos, almuerzos y cenas fáciles', 'Opciones saludables y tradicionales', 'Snacks, panes y postres incluidos', 'Ideal para aprovechar al máximo tu Air Fryer', 'Recibís todo junto en formato digital'];
export const UpsellModal = () => {
  const {
    isOpen,
    close
  } = useUpsell();
  useEffect(() => {
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, close]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center px-0 sm:px-4 py-0 sm:py-6 bg-black/60 backdrop-blur-sm overflow-y-auto" onClick={close} role="dialog" aria-modal="true" aria-labelledby="upsell-title" data-id="element-231">
      <div className="relative w-full sm:max-w-md bg-white sm:rounded-3xl rounded-t-3xl shadow-2xl my-auto sm:my-6" onClick={e => e.stopPropagation()} style={{
      animation: 'fadeUp 0.25s ease-out'
    }} data-id="element-232">
        {/* Close button */}
        <button onClick={close} aria-label="Cerrar" className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full bg-white/95 border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 transition-colors z-10" data-id="element-233">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-234">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-235"></line>
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-236"></line>
          </svg>
        </button>

        {/* Header band */}
        <div className="bg-gradient-to-r from-brand-red to-orange-500 px-5 pt-5 pb-4 rounded-t-3xl text-center" data-id="element-237">
          <span className="inline-block bg-yellow-300 text-brand-dark font-extrabold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-full shadow-sm" data-id="element-238">
            ⚡ Oferta especial por única vez
          </span>
          <h2 id="upsell-title" className="font-serif text-white text-xl sm:text-2xl font-semibold mt-3 leading-tight" data-id="element-239">
            Antes de finalizar tu compra…
          </h2>
          <p className="text-white/95 text-xs sm:text-sm mt-1.5 font-medium" data-id="element-240">
            Agregá <span className="font-bold" data-id="element-241">+1000 Recetas en Air Fryer</span>{' '}
            por solo <span className="font-bold" data-id="element-242">$3.990</span>
          </p>
        </div>

        {/* Body */}
        <div className="px-4 sm:px-5 py-4 space-y-4" data-id="element-243">
          {/* Product visual */}
          <div className="flex items-center gap-3 bg-brand-cream rounded-xl p-3 border border-amber-100" data-id="element-244">
            <img src="https://cdn.magicpatterns.com/uploads/1VetihpjRA4V9721FawG4Z/437_(1).webp" alt="1000 Recetas Argentinas para tu Freidora" className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg object-cover shadow-sm shrink-0" data-id="element-245" />
            <div className="flex-1 min-w-0" data-id="element-246">
              <p className="text-[10px] font-bold text-orange-700 uppercase tracking-wide mb-0.5" data-id="element-247">
                Bono complementario
              </p>
              <p className="font-serif text-base sm:text-lg font-semibold text-brand-dark leading-tight" data-id="element-248">
                +1000 Recetas en Air Fryer
              </p>
            </div>
          </div>

          {/* Emotional copy — condensed */}
          <p className="text-xs sm:text-sm text-gray-700 leading-relaxed" data-id="element-249">
            Completá tu colección con más de <strong data-id="element-250">1000 recetas</strong> para
            Air Fryer: desayunos, almuerzos, cenas, snacks, panes, postres y
            opciones fitness. Todo listo para usar.
          </p>

          {/* Price block */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-orange-100 rounded-xl p-3 sm:p-4 text-center" data-id="element-251">
            <div className="flex items-center justify-center gap-2 mb-1.5" data-id="element-252">
              <span className="text-xs sm:text-sm text-gray-500 line-through decoration-red-500" data-id="element-253">
                Antes: $10.000
              </span>
              <span className="bg-brand-red text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-254">
                -60%
              </span>
            </div>
            <p className="text-[10px] sm:text-xs font-bold text-orange-800 uppercase tracking-wide" data-id="element-255">
              Hoy junto a tu compra:
            </p>
            <p className="text-3xl sm:text-4xl font-bold text-brand-red tracking-tight" data-id="element-256">
              $3.990
            </p>
          </div>

          {/* Benefits — compact */}
          <ul className="space-y-1.5" data-id="element-257">
            {benefits.map(b => <li key={b} className="flex items-start gap-2.5 text-xs sm:text-sm text-gray-800" data-id="element-258">
                <span className="mt-0.5 shrink-0 w-4 h-4 rounded-full bg-green-100 text-brand-green flex items-center justify-center font-bold text-[10px]" data-id="element-259">
                  ✓
                </span>
                <span data-id="element-260">{b}</span>
              </li>)}
          </ul>

          {/* CTAs */}
          <div className="space-y-2 pt-1" data-id="element-261">
            <button onClick={goToUpsellCheckout} className="w-full bg-brand-orange hover:bg-orange-600 text-white font-bold py-3 px-4 rounded-full shadow-lg text-sm sm:text-base transition-colors leading-tight" data-id="element-262">
              Sí, agregar por solo $3.990
            </button>
            <button onClick={goToMainOnlyCheckout} className="w-full bg-transparent hover:bg-gray-50 text-gray-500 hover:text-gray-900 font-medium py-2 px-4 rounded-full text-xs sm:text-sm transition-colors underline underline-offset-4 decoration-gray-300" data-id="element-263">
              No gracias, continuar solo con mi compra
            </button>
          </div>

          <p className="text-[10px] sm:text-xs text-center text-gray-500 leading-relaxed" data-id="element-264">
            Se agrega automáticamente a tu compra y recibís todo junto en
            formato digital.
          </p>
        </div>
      </div>
    </div>;
};